import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

export default function StudentRoute({ children }) {
    const isLoggedIn = useAuth();
    const auth = useSelector((state) => state.auth);
   
   return isLoggedIn && auth.user.role=='student' ?   children : isLoggedIn && auth.user.role=='admin' ? <Navigate to='/admin/dashboard' /> : <Navigate to="/" />
 
}
